import composeStore from '../helpers/generate-pagination-data-store';
import composeParams from '../helpers/store-helpers/compose-params';

const initialStore = composeStore(
    'categoryProducts',
    ['listing'],
    '/api/my-menu-hierarchy',
    composeParams
);

export const state = () => ({
  ...initialStore.state,
});

export const mutations = {
  ...initialStore.mutation,
  reset(state) {
    Object.keys(state).forEach((key) => {
      // Reset arrays to empty, objects to {}, and primitives to null
      if (Array.isArray(state[key])) {
        state[key] = [];
      } else if (typeof state[key] === 'object' && state[key] !== null) {
        state[key] = {};
      } else {
        state[key] = null;
      }
    });
  },
};

export const getters = {
  ...initialStore.getter,
};

export const actions = {
  ...initialStore.action,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
